import {
  DocumentClassAttributes,
  OrderAttributes,
  SubRouteAttributes,
  TripAttributes,
} from "@albatrosdeveloper/ave-models-package";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import RouteGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity";
import { SelectionModel } from "@angular/cdk/collections";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  signal,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";
import { NgSelectModule } from "@ng-select/ng-select";
import { TRIP_STATUS_LIST } from "app/common/enums/trip-status.enum";
import { IRequestResult } from "app/common/interfaces";
import { BusinessPartnerService } from "app/modules/components/business-partners/business-partner/business-partner.service";
import { SalesOfficeService } from "app/modules/components/configuration/sales-office/sales-office.service";
import { WarehouseService } from "app/modules/components/configuration/warehouse/warehouse.service";
import { TripService } from "app/modules/components/reports/visits/visit-report/visit-report.service";
import { RouteGroupService } from "app/modules/components/routing/route-group/route-group.service";
import { SubRouteService } from "app/modules/components/routing/sub-routes/sub-route.service";
import { UpdateOrderService } from "app/modules/components/sales/update-order/update-order.service";
import { FormatOtherDateHourPipe } from "app/pipes/other-date.pipe";
import { WeightFormatPipe } from "app/pipes/weight-format.pipe";
import { validateOrdersByAction } from "app/utils/document-class-validation";
import { getCode } from "app/utils/method";
import { calculateTotalWeight } from "app/utils/weigth";
import { environment } from "environments/environment.prod";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { lastValueFrom, Subject, Subscription } from "rxjs";
import { EditType, OrderSelectionType } from "../../enums/typeEdit.enum";
import { IUpdateOrder } from "../../interfaces/order.interface";
import { RefreshContext } from "../../interfaces/refresh-context.interface";
import { LoadsService } from "../../loads.service";
import { OrderDetailsTableComponent } from "../order-details-table/order-details-table.component";

@Component({
  selector: "app-order-table",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatMenuModule,
    NgSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    MatRadioModule,
    WeightFormatPipe,
    OrderDetailsTableComponent,
    NgxMaterialTimepickerModule,
    OverlayModule,
    MatBadgeModule,
    FormatOtherDateHourPipe,
  ],
  templateUrl: "./order-table.component.html",
  styleUrl: "./order-table.component.scss",
})
export class OrderTableComponent implements OnInit, OnChanges {
  getCode = getCode;
  OrderSelectionType = OrderSelectionType;

  @Input() ordersData: OrderAttributes[];
  @Input() displayedColumns: string[] = [];
  @Input() loadCalculationMode: string | undefined;
  @Input() UMPActive: boolean = false;
  @Input() canJoin: boolean = true;
  @Input() canUnifyConditions: boolean = false;
  @Input() canCancel: boolean = false;
  @Input() documentClasses: DocumentClassAttributes[] = [];
  @Output() onSortChange: EventEmitter<{
    active: string;
    direction: "ASC" | "DESC";
  }> = new EventEmitter();
  @Output() ordersJoined = new EventEmitter<RefreshContext>();

  @Input() pendingModalOpen: boolean = false;
  @Input() pendingUserName: string = "";

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  @ViewChild("sortDetail1") sortDetail1: MatSort;
  @ViewChild("confirmDialog") confirmDialog!: TemplateRef<any>;
  @ViewChild("confirmBpDialog") confirmBpDialog!: TemplateRef<any>;

  private destroy$ = new Subject<void>();

  //displayedColumns: string[] = ['det','select','serial', 'subRoute','soldTo', 'shipTo','address', 'deliveryDateTime', 'weight', 'actions'];

  dataSource = new MatTableDataSource<OrderAttributes>();
  selection = new SelectionModel<any>(true, []);

  orderSelectionType: OrderSelectionType = OrderSelectionType.SINGLE;
  isNoOrderSelectionJoin: boolean = false;
  selectHeadOrder: OrderAttributes | null = null;
  selectedOrder: OrderAttributes | null = null;

  editOrderForm: FormGroup;
  companyId: string | null = null;
  minDate: Date;
  maxDate: Date;
  dateDeliverySubscription!: Subscription;
  minTime: string; // Hora mínima en formato "HH:mm"
  maxTime: String;

  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList = signal<SalesOfficeAttributes[]>([]);
  searchOffice = "";
  routeGroup = signal<RouteGroupAttributes[]>([]);
  routesList: SubRouteAttributes[] = [];
  listFilterRoutesList = signal<SubRouteAttributes[]>([]);
  searchRoute = "";
  trips = signal<TripAttributes[]>([]);
  statusList = [];

  listBusinessPartner: BusinessPartnerAttributes[] = [];
  isOtherRoute: boolean = false;

  @ViewChild("pendingOrderByUserModal")
  pendingOrderByUserModal!: TemplateRef<any>;
  dialogRefPendingOrderByUser: MatDialogRef<any>;

  pendingOrders: OrderAttributes[] = [];

  searchControl = new FormControl("");
  search: string = "";
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof OrderAttributes = "createdAt";
  sortDirection: "asc" | "desc" = "desc";

  constructor(
    private loadService: LoadsService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly warehouseService: WarehouseService,
    private readonly subRouteService: SubRouteService,
    private readonly routeGroupService: RouteGroupService,
    private readonly tripService: TripService,
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly updateOrderService: UpdateOrderService,
    private readonly loadsService: LoadsService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.editOrderForm = this.fb.group({
      salesOffice: [""],
      routeGroup: [""],
      route: [""],
      dateLoad: [""],
      timeLoad: [""],
      dateDelivery: [""],
      timeDelivery: [""],
      trip: [null],
    });

    if (this.ordersData) {
      this.dataSource.data = structuredClone(this.ordersData);
      this.filterData();
      this.validateRequirements();
    }
    this.statusTrip();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ordersData?.currentValue) {
      this.dataSource.data = structuredClone(changes.ordersData.currentValue);
      this.filterData();
      this.validateRequirements();
    } else if (changes.documentClasses?.currentValue)
      this.validateRequirements();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // Configuración de los selects múltiples
  multiSelectConfig = {
    salesOffice: {
      formControlName: "route",
      searchCtrl: new FormControl(),
      filteredData: signal<any[]>([]),
      isIndeterminate: false,
      isAllSelected: false,
      options: signal<SalesOfficeAttributes[]>([]),
    },
    route: {
      formControlName: "route",
      searchCtrl: new FormControl(),
      filteredData: signal<any[]>([]),
      isIndeterminate: false,
      isAllSelected: false,
      options: signal<SubRouteAttributes[]>([]),
    },
  };

  /**
   * Valida los requerimientos de las clases de documentos
   * de los documentos de carga
   */
  private validateRequirements(): void {
    this.dataSource.data = this.dataSource.data.map((order) => {
      const docClass = this.documentClasses.find(
        (d) => d?._id?.toString() === order?.class?._id.toString()
      );
      return {
        ...order,
        canJoin: validateOrdersByAction([order], this.documentClasses, "JOIN"),
        canUnifyConditions: docClass?.canUnifyConditions ?? false,
      };
    });
    this.dataSource._updateChangeSubscription();
  }

  private convertTo24HourFormat(timeString: string): string {
    if (!timeString) return "";

    const timeRegex = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i;
    const match = timeString.match(timeRegex);

    if (!match) return "";

    let [_, hours, minutes, period] = match;
    let hourNumber = parseInt(hours, 10);

    if (period.toUpperCase() === "PM" && hourNumber !== 12) {
      hourNumber += 12;
    } else if (period.toUpperCase() === "AM" && hourNumber === 12) {
      hourNumber = 0;
    }

    return `${hourNumber.toString().padStart(2, "0")}:${minutes}`;
  }

  getDateTime(dateF: string, timeF: string): Date | null {
    const date = this.editOrderForm.get(dateF)?.value;
    const time = this.editOrderForm.get(timeF)?.value;

    let formattedDate;

    if (typeof date === "object") {
      let convertedDate = new Date(date);
      let convertedDay = convertedDate.getDate();
      let convertedMonth = convertedDate.getMonth() + 1;
      let convertedYear = convertedDate.getFullYear();
      formattedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    } else {
      formattedDate = date;
    }

    if (!formattedDate || !time) return null;

    const time24 = this.convertTo24HourFormat(time);
    const [hours, minutes] = time24.split(":").map(Number);

    const dateTime = new Date();
    const [year, month, day] = formattedDate.split("-").map(Number);

    dateTime.setFullYear(year, month - 1, day);
    dateTime.setHours(hours ?? 0, minutes ?? 0, 0, 0);

    console.table({ dateTime, formattedDate, time, hours, minutes });

    return dateTime; //.toISOString();
  }

  setDateTimeFromISOToForm(
    isoString: string,
    dateF: string = "dateDelivery",
    timeF: string = "timeDelivery"
  ): void {
    if (!isoString) return;

    const dateObject = new Date(isoString);
    //const date = dateObject.toISOString().split('T')[0];

    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const formattedTime = this.convertTo12HourFormat(hours, minutes);

    this.editOrderForm.patchValue({
      [dateF]: dateObject,
      [timeF]: formattedTime,
    });
  }

  private convertTo12HourFormat(hours: number, minutes: number): string {
    const period = hours >= 12 ? "PM" : "AM";
    const hour12 = hours % 12 || 12;

    return `${hour12}:${minutes.toString().padStart(2, "0")} ${period}`;
  }

  private getSortField(sortActive: string): keyof OrderAttributes {
    const sortFieldMapping: Record<string, keyof OrderAttributes> = {
      serial: "serial",
      soldTo: "soldTo",
      shipTo: <any>"shipTo",
      deliveryDateTime: <any>"deliveryDateTime",
      weight: <any>"weight",
    };
    return sortFieldMapping[sortActive] || "deliveryDateTime";
  }

  changeSort(event: { active: string; direction: "asc" | "desc" }) {
    if (this.dataSource.data.length === 0) return;
    const direction = event.direction === "asc" ? "ASC" : "DESC";
    this.onSortChange.emit({
      active: this.getSortField(event.active),
      direction,
    });
  }

  filterData() {
    this.dataSource.data = this.dataSource.data.map((row) => ({
      ...row,
      weight: calculateTotalWeight(row, this.loadCalculationMode),
    }));
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    //return numSelected === numRows;
    return numSelected >= 1;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row) => {
          //if(row.) {
          this.selection.select(row);
          //}
        });
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${row.position + 1}`;
  }

  closeDetails(): void {
    this.selectedOrder = null;
  }

  async toggleDetails(order: OrderAttributes): Promise<void> {
    if (this.selectedOrder && this.selectedOrder._id === order._id) {
      this.closeDetails();
      return;
    }

    this.selectedOrder = order;
  }

  today() {
    return new Date();
  }

  validateEditOrderModal() {
    if (this.selection.selected.length == 0) {
      return;
    }

    const uniqueRoutes = new Set(
      this.selection.selected.map((order) => order.subRoute?._id || "sin_ruta")
    );
    const uniqueDeliveryDate = new Set(
      this.selection.selected.map(
        (order) => order.deliveryDateTime || "sin_Fecha"
      )
    );

    let message = "";
    let type = null;

    if (uniqueRoutes.size > 1 && uniqueDeliveryDate.size > 1) {
      message =
        "Las órdenes seleccionadas pertenecen a diferentes rutas y tienen diferentes fechas de entrega. Si continúa, la edición se aplicará a todas las órdenes seleccionadas. ¿Desea continuar?";
      type = EditType.BOTH_NULL;
    } else if (uniqueRoutes.size > 1) {
      message =
        "Las órdenes seleccionadas pertenecen a diferentes rutas. Si continúa, la edición se aplicará a todas las órdenes seleccionadas. ¿Desea continuar?";
      type = EditType.ROUTE_NULL;
    } else if (uniqueDeliveryDate.size > 1) {
      message =
        "Las órdenes seleccionadas tienen diferentes fechas de entrega. Si continúa, la edición se aplicará a todas las órdenes seleccionadas. ¿Desea continuar?";
      type = EditType.DATE_NULL;
    }

    if (message) {
      this.openConfirmDialog(message, this.selection.selected[0], type);
    } else {
      this.orderSelectionType = OrderSelectionType.MULTIPLE;
      this.showEditOrderModal(this.selection.selected[0]);
    }
  }

  openConfirmDialog(
    message: string,
    order: OrderAttributes,
    editType: EditType | null
  ): void {
    this.dialog
      .open(this.confirmDialog, {
        data: { title: "Confirmar registro", message: message },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.showEditOrderModal(order, editType);
          this.orderSelectionType = OrderSelectionType.MULTIPLE;
        }
      });
  }

  async showEditOrderModal(order: OrderAttributes, editType?): Promise<void> {
    const safeEditType = editType ?? EditType.DEFAULT;
    this.editOrderForm.reset();
    this.companyId = order.company?._id.toString();

    let route = order.subRoute ? order.subRoute._id : "";
    let trip = order.trip ? order.trip._id : null;
    let deliveryDateTime = order.deliveryDateTime ?? "";

    if (
      safeEditType === EditType.ROUTE_NULL ||
      safeEditType === EditType.BOTH_NULL
    ) {
      route = "";
    }
    if (
      safeEditType === EditType.DATE_NULL ||
      safeEditType === EditType.BOTH_NULL
    ) {
      deliveryDateTime = "";
    }

    let salesOffice = null;
    let routeGroup = null;

    if (!route) {
      await this.getAllSalesOfficeList(this.companyId);
      await this.fetchRouteGroups(this.companyId);
    } else {
      await this.fetchRoutes(this.companyId);
      const selectedRoute = this.listFilterRoutesList().find(
        (r) => r._id === route
      );

      if (selectedRoute) {
        salesOffice = selectedRoute.salesOffice?._id ?? null;
        routeGroup = selectedRoute.routeGroup?._id ?? null;
      }

      await this.getAllSalesOfficeList(this.companyId);
      await this.fetchRouteGroups(this.companyId);
    }

    this.editOrderForm.patchValue({
      salesOffice: salesOffice,
      routeGroup: routeGroup,
      route: route,
      trip: trip,
    });

    let orderIds: number[];
    if (
      this.orderSelectionType === OrderSelectionType.MULTIPLE &&
      Array.isArray(this.selection.selected)
    ) {
      orderIds = this.selection.selected.map((order) => order.shipTo.id);
    } else {
      orderIds = [order.shipTo.id];
    }

    this.getAllBusinesseliveryRoutes(orderIds);
    this.fetchTrip();
    this.selectHeadOrder = safeEditType === EditType.DEFAULT ? order : null;
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      width: "90%",
      disableClose: true,
    }); //panelClass: "form-modal",
  }

  openMConfirmDialog(): void {
    const ordersToJoinFiltered = this.selection.selected.filter(
      (order) => order.canJoin
    );
    if (ordersToJoinFiltered.length == 0) {
      this.openConfirmSDialog(
        "Los pedidos seleccionados no están permitidos para unificarse."
      );
      return;
    }
    this.dialog
      .open(this.confirmDialog, {
        data: {
          title: "Confirmar",
          innerHTML: `
            <p>Los siguientes pedidos pueden ser unificados:</p>
            <ul>
              ${ordersToJoinFiltered.map((order) => `<li>${order.serial}</li>`).join("")}
            </ul>
            <p>¿Está seguro que desea unificarlos?</p>
          `,
        },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.validateJoinOrderModal(ordersToJoinFiltered);
        }
      });
  }

  validateJoinOrderModal(ordersToJoinFiltered: OrderAttributes[] | any) {
    if (this.selection.selected.length == 0) {
      return;
    }

    const allCanUnify = ordersToJoinFiltered.every(
      (order) => order.canUnifyConditions
    );
    const uniqueClass = new Set(
      ordersToJoinFiltered.map((order) => order.class?._id || "sin_class")
    );
    const materialMap = new Map<string, Set<number>>();

    ordersToJoinFiltered.forEach((order) => {
      order.detail.forEach((item) => {
        const materialId = item.material?._id || ("sin_item" as any);
        const unitPrice = item.unitPrice;

        if (!materialMap.has(materialId)) {
          materialMap.set(materialId, new Set());
        }
        materialMap.get(materialId)?.add(unitPrice);
      });
    });

    let message = "";
    let hasPriceM = false;

    materialMap.forEach((prices, materialId) => {
      if (prices.size > 1) {
        hasPriceM = true;
      }
    });

    if (!allCanUnify) {
      if (uniqueClass.size > 1 && hasPriceM) {
        message =
          "Las órdenes seleccionadas pertenecen a diferentes clases y tienen variaciones en los precios de los materiales.";
        this.openConfirmSDialog(message);
      } else if (uniqueClass.size > 1) {
        message = "Las órdenes seleccionadas pertenecen a diferentes clases.";
        this.openConfirmSDialog(message);
      } else if (hasPriceM) {
        message =
          "Las órdenes seleccionadas tienen variaciones en los precios de los materiales.";
        this.openConfirmSDialog(message);
      }
    }
    this.joinOrders(ordersToJoinFiltered);
  }

  validateIfJoinButtonIsShow() {
    this.isNoOrderSelectionJoin = false;
    let countToJoin: number = 0;
    this.selection.selected.forEach((order) => {
      if (order.canJoin) countToJoin++;
    });
    if (countToJoin > 1) this.isNoOrderSelectionJoin = false;
    else this.isNoOrderSelectionJoin = true;
  }

  openConfirmSDialog(message: string): void {
    this.dialog
      .open(this.confirmDialog, {
        data: { title: "Advertencia", message: message },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.isNoOrderSelectionJoin = true;
        }
      });
  }

  showCancelOrderModal(order?: OrderAttributes): void {
    if (
      this.orderSelectionType == OrderSelectionType.MULTIPLE &&
      this.selection.selected.length == 0
    ) {
      this.snackBar.open(
        "Seleccione al menos un documento para anular.",
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    this.dialog
      .open(this.confirmDialog, {
        data: {
          title: `Anular ${this.orderSelectionType == OrderSelectionType.SINGLE ? "documento" : "documentos"}`,
          message: `¿Está seguro que desea anular ${this.orderSelectionType == OrderSelectionType.SINGLE ? "el documento" : "los documentos"}?`,
        },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe(async (result) => {
        if (result == true) {
          const orderIds: string[] =
            this.orderSelectionType == OrderSelectionType.SINGLE
              ? [String(order._id)]
              : this.getOrderIds(order);

          try {
            await Promise.all(
              orderIds.map((id) =>
                lastValueFrom(
                  this.updateOrderService.updateOrder(id, { statusId: 0 })
                )
              )
            );
            this.snackBar.open("Anulación exitosa", "Cerrar", {
              duration: 3000,
            });
            if (this.selection.selected.length > 0) this.selection.clear();
            this.changeSort({ active: "creationDateTime", direction: "asc" });
          } catch (err) {
            this.snackBar.open(
              err.error?.message || "Error en la anulación",
              "Cerrar",
              { duration: 3000 }
            );
          }
        }
      });
  }

  getInvalidShipTo(
    orders: OrderAttributes
  ): { shipToName: string; serial: string }[] {
    const routeForm =
      this.routesList
        .find(
          (subRoute) => String(subRoute._id) === this.editOrderForm.value.route
        )
        ?.routes.map((route) => String(route._id)) ?? [];

    const ordersToCheck =
      this.orderSelectionType === OrderSelectionType.MULTIPLE &&
      Array.isArray(this.selection.selected)
        ? this.selection.selected
        : [orders ?? this.selectHeadOrder];

    return ordersToCheck
      .filter((order) => {
        const belongsToRoute = this.listBusinessPartner.some((bp) => {
          return (
            bp.id === order.shipTo.id &&
            bp.routes &&
            bp.routes.some((route) => routeForm.includes(String(route._id)))
          ); // Aquí está el cambio
        });
        return !belongsToRoute; // Filtrar solo los que NO pertenecen a la ruta
      })
      .map((order) => ({
        shipToName: order.shipTo.name,
        serial: order.serial,
      }));
  }

  isValidDeliveryDay(date: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (!date) {
        resolve(true);
        return;
      }

      const selectedDate = new Date(date);
      const selectedDayValue =
        selectedDate.getDay() === 0 ? 7 : selectedDate.getDay(); // Ajustar Domingo (0) a 7

      const businessPartner: any = this.listBusinessPartner.find(
        (bp: any) => bp.deliverySubRoutes
      );

      if (
        !businessPartner ||
        !Array.isArray(businessPartner.deliverySubRoutes) ||
        businessPartner.deliverySubRoutes.length === 0
      ) {
        resolve(true); // Si no hay subrutas, permitir la fecha
        return;
      }

      // Obtener los días permitidos de todas las `deliverySubRoutes`
      const allowedDays = businessPartner.deliverySubRoutes
        ?.flatMap(
          (subRoute: any) =>
            subRoute.frecuencies?.flatMap((freq: any) => freq.days) || []
        )
        .filter(
          (value: number, index: number, self: number[]) =>
            self.indexOf(value) === index
        ); // Eliminar duplicados

      if (!allowedDays.includes(selectedDayValue)) {
        this.dialog
          .open(this.confirmDialog, {
            data: {
              title: "Advertencia",
              message:
                "El o los clientes indicados no se visitan en el día seleccionado",
            },
            panelClass: "delete-modal",
            disableClose: true,
          })
          .afterClosed()
          .subscribe(() => {
            resolve(true);
          });
      } else {
        resolve(true);
      }
    });
  }

  async updateOrder(orders: OrderAttributes): Promise<void> {
    const { trip, dateDelivery, timeDelivery, route } =
      this.editOrderForm.value;

    // Validar campos requeridos
    if (trip && (!dateDelivery || !timeDelivery || !route)) {
      this.snackBar.open(
        "Debe seleccionar una fecha, hora de entrega y/o ruta",
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    const selectedDate = new Date(dateDelivery);
    const minDate = new Date(this.minDate);
    const maxDate = new Date(this.maxDate);
    selectedDate.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);
    maxDate.setHours(0, 0, 0, 0);

    // Si la fecha está fuera del rango, mostrar alerta y detener el proceso
    if (selectedDate < minDate || selectedDate > maxDate) {
      this.snackBar.open(
        `La fecha seleccionada está fuera del rango permitido (${minDate.toLocaleDateString()} - ${maxDate.toLocaleDateString()}).`,
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    let orderIds = this.getOrderIds(orders);
    const invalidOrders = this.getInvalidShipTo(orders);
    if (invalidOrders.length > 0) {
      this.isOtherRoute = true;
      this.openConfirmBPDialog(invalidOrders);
      return;
    }

    await this.isValidDeliveryDay(dateDelivery); //validar day

    let dateTimeDelivery = this.getDateTime("dateDelivery", "timeDelivery");
    let dateTimeLoad = this.getDateTime("dateLoad", "timeLoad");

    let send: IUpdateOrder = {
      orderIds: orderIds,
      subRouteId: this.editOrderForm.value.route,
      deliveryDateTime: dateTimeDelivery
        ? dateTimeDelivery.toISOString()
        : null,
      //loadDateTime: dateTimeLoad ? dateTimeLoad.toISOString() : null,
      tripId: this.editOrderForm.value.trip ?? null,
    };

    this.loadService.updateOrder(send).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        this.dialogRefEdit.close();
        if (this.selection.selected.length > 0) this.selection.clear();
        this.changeSort({ active: "serial", direction: "desc" }); //volver a llamar servicio
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  getOrderIds(orders: OrderAttributes): string[] {
    if (
      this.orderSelectionType === OrderSelectionType.MULTIPLE &&
      Array.isArray(this.selection.selected)
    ) {
      return this.selection.selected.map((order) => String(order._id));
    }
    return [String((orders as OrderAttributes) ?? this.selectHeadOrder._id)];
  }

  openConfirmBPDialog(invalidOrders: any[]): void {
    this.dialog
      .open(this.confirmBpDialog, {
        data: { invalidOrders },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
        }
      });
  }

  joinOrders(ordersToJoinFiltered: OrderAttributes[]): void {
    let send: IUpdateOrder = {
      orderIds: ordersToJoinFiltered.map((order) => String(order._id)),
    };

    this.loadService.joinOrder(send).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
          duration: 3000,
        });
        if (this.selection.selected.length > 0) this.selection.clear();

        this.ordersJoined.emit({
          type: "unify",
          metadata: { affectedOrderIds: send.orderIds },
        });
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar registro",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }

  onCloseEditOrderModal() {
    this.editOrderForm.reset();
    this.dialogRefEdit.close("Close");
  }

  //filter form
  private getAllSalesOfficeList(companyId: string): void {
    this.salesOfficeService.findToComboBox(companyId).subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.listFilterSalesOfficeList.update(() =>
          this.salesOfficeList.slice()
        );
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error fetching sales office",
          "Cerrar",
          { duration: 5000 }
        );
      },
    });
  }

  changueOptionsSalesOffice(event) {
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSalesOfficeList.update(() =>
      this.salesOfficeList.filter(
        (item) =>
          item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
          item.name.toLowerCase().indexOf(search) > -1
      )
    );
  }

  private fetchRouteGroups(companyId: string): void {
    this.routeGroupService.findByCompanyId(companyId).subscribe((res) => {
      this.routeGroup.update(() => res.data);
    });
  }

  changeSearchRoute() {
    this.listFilterRoutesList.update(() => []);
    this.fetchRoutes(this.companyId);
  }

  private fetchRoutes(companyId: string): Promise<void> {
    return new Promise((resolve) => {
      this.subRouteService
        .findToComboBoxByCompanyAndModel(
          companyId,
          this.editOrderForm.value.salesOffice, //sales Office
          this.editOrderForm.value.routeGroup, //route Grouo
          "08"
        )
        .subscribe((res) => {
          this.routesList = res.data;
          this.listFilterRoutesList.update(() => this.routesList.slice());
          resolve();
        });
    });
  }

  changueOptionsRoute(event) {
    if (!this.routesList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterRoutesList.update(() => this.routesList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterRoutesList.update(() =>
      this.routesList.filter(
        (item) => item.name.toLowerCase().indexOf(search) > -1
      )
    );
  }

  private fetchTrip(): void {
    let dateTime = this.getDateTime("dateDelivery", "timeDelivery");
    const now = new Date();
    const nowUTC = new Date(now.getTime() - now.getTimezoneOffset() * 60000); // Convertimos a UTC

    let findRoute = this.listFilterRoutesList().find(
      (ele) => ele._id == this.editOrderForm.value.route
    );
    if (!findRoute) {
      //this.snackBar.open('Sin ruta seleccionada', 'Cerrar', { duration: 3000 });
      return;
    }

    this.editOrderForm.patchValue({
      dateLoad: null,
      timeLoad: null,
      trip: null,
    });
    this.isOtherRoute = false;

    this.tripService
      .findToComboBox(findRoute.id, nowUTC, false)
      .subscribe((res) => {
        //dateTime el viaje ya no dependera de la fecha
        this.trips.update(() => res.data);
        if (Array.isArray(res.data) && res.data.length == 1) {
          this.editOrderForm.get("trip").setValue(res.data[0]._id);
          this.changeTrip();
        }
      });
  }

  changeTrip() {
    const tripSelected = this.trips().find(
      (trip) => trip._id == this.editOrderForm.value.trip
    );
    if (tripSelected) {
      let loadDateTime = tripSelected.loadDateTime ?? "";
      this.setDateTimeFromISOToForm(
        loadDateTime as string,
        "dateLoad",
        "timeLoad"
      );

      //date
      const formatTimeLocal = (date: Date) =>
        date.toLocaleTimeString(undefined, {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });

      this.minDate = new Date(tripSelected.dateHourStartTeoric);
      this.maxDate = new Date(tripSelected.dateHourEndTeoric);

      //hour
      this.dateDeliverySubscription?.unsubscribe();
      // Suscribirse al cambio de fecha de entrega
      this.dateDeliverySubscription = this.editOrderForm
        .get("dateDelivery")
        ?.valueChanges.subscribe((selectedDate) => {
          this.updateMinTime(selectedDate, tripSelected);
        });
      this.setTripDateTime(tripSelected);
    }
  }

  private setTripDateTime(tripSelected: any) {
    // Obtener la fecha teórica de inicio del viaje
    const startDate = new Date(tripSelected.dateHourStartTeoric);

    // Establecer la hora a las 6:00 AM
    startDate.setHours(6, 0, 0, 0);

    // Formatear la fecha para el datepicker
    this.editOrderForm.get("dateDelivery").setValue(startDate);

    // Formatear la hora para el timepicker (06:00)
    this.editOrderForm.get("timeDelivery").setValue("06:00");
  }

  cleanDeliveryDate() {
    this.editOrderForm.get("dateDelivery").setValue(null);
    this.editOrderForm.get("timeDelivery").setValue(null);
    this.minDate = null;
    this.maxDate = null;
  }

  updateMinTime(selectedDate: Date, trip: any) {
    if (!selectedDate || !trip) return;

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startTime = new Date(trip.dateHourStartTeoric);
    const endTime = new Date(trip.dateHourEndTeoric);

    const today = new Date();
    const isToday = selectedDate.toDateString() === today.toDateString();

    if (isToday) {
      const nowUTC = new Date(
        today.getTime() - today.getTimezoneOffset() * 60000
      );
      //this.minTime = nowUTC.toISOString().substring(11, 16);
      this.minTime = nowUTC.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: userTimeZone,
      });
    } else {
      //this.minTime = startTime.toISOString().substring(11, 16);
      this.minTime = startTime.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: userTimeZone,
      });
    }

    // Asegurar que la hora máxima no sea menor que la mínima
    //this.maxTime = endTime.toISOString().substring(11, 16);
    this.maxTime = endTime.toLocaleTimeString(undefined, {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: userTimeZone,
    });
    if (this.maxTime < this.minTime) {
      this.maxTime = "23:59";
    }
  }

  private getAllBusinesseliveryRoutes(orderIds: number[]): void {
    const options = {
      search: null,
      currentPage: 1,
      //limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.businessPartnerService
      .findToComboDeliveryRoutes(options, orderIds)
      .subscribe({
        next: (res: IRequestResult<BusinessPartnerAttributes[]>) => {
          this.listBusinessPartner = res.data;
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error fetching customer",
            "Cerrar",
            { duration: 5000 }
          );
        },
      });
  }
  //end filter form

  goToTravel(element: OrderAttributes) {
    if (element.trip?.id) {
      const queryParams = { tripId: element.trip.id };
      const urlTree = this.router.createUrlTree(
        ["monitor", "principal-screen"],
        { queryParams }
      );
      const absoluteUrl =
        window.location.origin + this.router.serializeUrl(urlTree);
      window.open(absoluteUrl, "_blank");
    }
  }

  showPendingOrdersByUser(order: OrderAttributes, userType: string) {
    let companyId = environment.companyId;

    const sortField = this.getSortField(this.sortActive);
    const sortDirection: "ASC" | "DESC" =
      this.sortDirection === "asc" ? "ASC" : "DESC";

    let options = {
      currentPage: this.pageIndex,
      limitPerPage: this.pageSize,
      search: this.search,
      sort: sortField,
      sortDirection: sortDirection,
    };

    let soldToId = userType == "soldTo" ? order?.soldTo.id ?? null : null;
    let shipToId = userType == "shipTo" ? order?.shipTo.id ?? null : null;

    this.pendingUserName =
      userType == "soldTo" ? order?.soldTo?.name : order?.shipTo?.name;

    this.pendingModalOpen = true;

    this.dialogRefPendingOrderByUser = this.dialog.open(
      this.pendingOrderByUserModal,
      { width: "90%", disableClose: true }
    );

    this.dialogRefPendingOrderByUser.afterClosed().subscribe(() => {
      this.pendingOrders = [];
      this.pendingModalOpen = false;
    });

    this.loadsService
      .findPendingOrdersByBP(
        "DT003",
        companyId,
        null,
        soldToId,
        shipToId,
        options
      )
      .subscribe((res) => {
        this.pendingOrders = res?.data?.[0]?.data ?? [];
      });
  }

  getTripStatusLabel(statusId: number): string {
    const status = this.statusList.find((s) => s.code === statusId);
    return status ? status.value : "Sin estado";
  }
  statusTrip() {
    this.statusList = TRIP_STATUS_LIST;
  }

  isThereOrderSourceTransaction(element: any): boolean {
    return (
      element.type.code == "DT003" &&
      Array.isArray(element?.sourceTransactions) &&
      element.sourceTransactions.some((t) => t?.type?.code === "DT002")
    );
  }

  goToOrder(element: OrderAttributes) {
    if (element?.serial && Array.isArray(element?.sourceTransactions)) {
      const orderIds = element.sourceTransactions
        .filter((t) => t?.type?.code === "DT002")
        .map((t) => t.serial)
        .toString();

      if (orderIds.length > 0) {
        const queryParams = { orderIds: orderIds };
        const urlTree = this.router.createUrlTree(
          ["master", "sales", "orders-list"],
          { queryParams }
        );
        const absoluteUrl =
          window.location.origin + this.router.serializeUrl(urlTree);
        window.open(absoluteUrl, "_blank");
      }
    }
  }

  disunifyOrderModal(order?: OrderAttributes): void {
    if (!order || !order._id) {
      this.snackBar.open("Documento no válido para desunificar.", "Cerrar", {
        duration: 3000,
      });
      return;
    }

    // Validación específica del operationType
    if (order.operationType !== 4) {
      this.snackBar.open(
        "Solo se pueden desunificar documentos unificados.",
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    this.dialog
      .open(this.confirmDialog, {
        data: {
          title: "Desunificar documento",
          message: "¿Está seguro que desea separar este documento?",
        },
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe(async (result) => {
        if (result == true) {
          try {
            // Enviamos solo el serial del documento
            await lastValueFrom(
              this.updateOrderService.desunifyOrder({
                serial: order._id.toString(),
              })
            );
            this.snackBar.open("Desunificación exitosa", "Cerrar", {
              duration: 3000,
            });
            if (this.selection.selected.length > 0) this.selection.clear();
            this.changeSort({ active: "creationDateTime", direction: "asc" });
          } catch (err) {
            this.snackBar.open(
              err.error?.message || "Error en la desunificación",
              "Cerrar",
              { duration: 3000 }
            );
          }
        }
      });
  }
}
